import actions, {
  ChangePasswordActions,
  ResendOtpActions,
  setNewPasswordActions,
  VerifyOtpActions,
  IsFirstTimeLoginActions,
  IsForgotPasswordActions,
} from "./authActions";

const initialState = {
  idToken: null,
  loginCredentials: null,
  VerifyOTPToken: null,
  verfyOTPAcessToken: null,
  maskedUsername: null,
  expiresIn: 0,
  statusMessage: "",
  status: "idle",
  error: null,
  checkLogin: null,
  userData: null,
  loggedInRoleType: "",
  logoutData: null,
  logoutStatus: null,
  partnerFirmDetails: null,
  userId: null,
};

export default function LoginData(state = initialState, { type, payload }) {
  switch (type) {
    case actions.LOGIN:
      return {
        ...state,
        status: "loading",
        error: null,
      };
    case actions.LOGIN_SUCCESS:
      return {
        ...state,
        accessToken: payload.data.dto?.accessToken,
        idToken: payload.data.dto.accessToken?.access_token,
        userData: payload.data.dto,
        loginCredentials: payload,
        partnerFirmDetails: payload.data?.partnerFirmDetails,
        statusMessage: "Logged In Successfully",
        error: null,
        logoutStatus: null,
        userId: payload.data?.dto?.userId || null,
      };
    case actions.LOGIN_ERROR:
      return {
        ...state,
        error: payload,
        status: "error",
        statusMessage: "Invalid Credentials",
        VerifyOTPToken: null,
      };
    case actions.LOGOUT_REQUEST:
      return {
        ...state,
        status: "loading",
        statusMessage: "Logging Out of the System",
      };
    case actions.LOGOUT_SUCCESS:
      return {
        ...initialState,
      };
    case actions.LOGOUT_ERROR:
      return {
        ...state,
        status: "error",
        statusMessage: "Failed to Logout",
      };

    ///ISFIRST TIME LOGIN//
    case IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN:
      return {
        ...state,
        error: null,
      };
    case IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN_SUCCESS:
      return {
        ...state,
        error: null,
        checkLogin: payload.data,
        PermissionData: [],
        maskedUsername: payload.data?.dto?.maskedUsername,
        logoutStatus: null,
        userId: payload.data?.dto?.userId || null,
      };
    case IsFirstTimeLoginActions.IS_FIRST_TIME_LOGIN_ERROR:
      return {
        ...state,
        error: payload,
      };
    case IsFirstTimeLoginActions.UPDATE_LOGIN_STATUS:
      return {
        ...state,
        partnerFirmDetails: {
          partnerFirmStatus: "FOR_VERIFICATION",
        },
        checkLogin: {
          ...state.checkLogin,
          partnerFirmDetails: {
            partnerFirmStatus: "FOR_VERIFICATION",
          },
        },
      };

    case IsForgotPasswordActions.IS_FORGOT_PASSWORD:
      return {
        ...state,
        error: null,
      };
    case IsForgotPasswordActions.IS_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        logoutStatus: null,
      };
    case IsForgotPasswordActions.IS_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        error: payload,
      };
    case ResendOtpActions.RESEND_OTP:
      return {
        ...state,
        error: null,
      };
    case ResendOtpActions.RESEND_OTP_SUCCESS:
      return {
        ...state,
        error: null,
        logoutStatus: null,
      };
    case ResendOtpActions.RESEND_OTP_ERROR:
      return {
        ...state,
        error: payload,
      };

    case VerifyOtpActions.VERIFY_OTP:
      return {
        ...state,
        error: null,
      };
    case VerifyOtpActions.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        error: null,
        VerifyOTPToken: payload.data.dto?.accessToken?.access_token,
        verfyOTPAcessToken: payload.data.dto?.accessToken,
        logoutStatus: null,
      };
    case VerifyOtpActions.VERIFY_OTP_ERROR:
      return {
        ...state,
        error: payload,
      };

    case setNewPasswordActions.SET_NEW_PASSWORD:
      return {
        ...state,
        error: null,
      };
    case setNewPasswordActions.SET_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        accessToken: payload.data.dto?.accessToken,
        idToken: payload.data.dto.accessToken?.access_token,
        userData: payload.data.dto,
        loginCredentials: payload,
        error: null,
        logoutStatus: null,
      };
    case setNewPasswordActions.SET_NEW_PASSWORD_ERROR:
      return {
        ...state,
        error: payload,
      };
    case ChangePasswordActions.CHANGE_PASSWORD:
      return {
        ...state,
        error: null,
      };
    case ChangePasswordActions.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: null,
        accessToken: payload.data.dto?.accessToken,
        idToken: payload.data.dto.accessToken?.access_token,
        logoutStatus: null,
      };
    case ChangePasswordActions.CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
}
